import React from "react";
import { Link, NavLink } from "react-router-dom";
import MobileNav from "./mobileNav";
import { useState } from "react";
const Header = ({ setIsActive, isActive }) => {
  const [navshow, setNavshow] = useState(false);

  const handleNav = () => {
    setNavshow(!navshow);
  };
  return (
    <>
      {/* <div className="">
        <button
          type="button"
          onClick={handleNav}
          class="mobile-nav-toggle d-lg-none"
          style={{ position: "fixed", zIndex: "9999999" }}
        >
          {!navshow ? <i class="fa fa-bars"></i> : <i class="fa fa-close"></i>}
        </button>
        <header id="header" className="header-scrolled">
          <div className="container-fluid content flexCetner">
            <div className="logo float-left">
              <Link to="/" className="scrollto">
                <img
                  src={require("../../static/img/logo.png")}
                  alt="logo"
                  className="img-fluid"
                />
              </Link>
            </div>

            <nav className="main-nav ml-auto d-none d-lg-block">
              <ul>
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/aboutus">About DMT</NavLink>
                </li>
                <li>
                  <NavLink to="/meettheteam">Our Team</NavLink>
                </li>
                <li>
                  <NavLink to="/contact">Contact </NavLink>
                </li>
                

                <li>
                  <Link
                    to="https://services.dmtkendra.com/Home/couponfares/Login.aspx"
                    className="loginBtn _T"
                    target="_blank"
                  >
                    DMT Login
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </header>
      </div> */}
      <div className="tk-nav-wrapper">
        {/* Premium Mobile Navigation Trigger */}
        <button
          type="button"
          onClick={handleNav}
          className={`tk-mobile-toggle d-lg-none ${navshow ? 'is-active' : ''}`}
          style={{ position: "fixed", zIndex: "9999999", top: "2px" }}
        >
          {!navshow ? <i className="fa fa-bars"></i> : <i className="fa fa-close"></i>}
        </button>

        {/* Main Corporate Header */}
        <header id="header" className="tk-main-header header-scrolled">
          <div className="container-fluid tk-nav-container">

            {/* Brand Logo Zone */}
            <div className="tk-logo-area">
              <Link to="/" className="scrollto">
                <img
                  src={require("../../static/img/logo.png")}
                  alt="logo"
                  className="img-fluid tk-brand-img"
                />
              </Link>
            </div>

            {/* Navigation Menu Links */}
            <nav className="tk-navbar-links ml-auto d-none d-lg-block">
              <ul>
                <li>
                  <NavLink to="/" exact activeClassName="tk-active-link">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/aboutus" activeClassName="tk-active-link">About DMT</NavLink>
                </li>
                <li>
                  <NavLink to="/meettheteam" activeClassName="tk-active-link">Our Team</NavLink>
                </li>
                <li>
                  <NavLink to="/contact" activeClassName="tk-active-link">Contact</NavLink>
                </li>

                {/* Premium Corporate Action Button */}
                {/* <li className="tk-action-item">
                  <Link
                    to="https://services.dmtkendra.com/Home/couponfares/Login.aspx"
                    className="tk-login-btn-premium"
                    target="_blank"
                  >
                    DMT Login
                    <i className="fa fa-arrow-right ml-2 tk-btn-icon"></i>
                  </Link>
                </li> */}
              </ul>
            </nav>

          </div>
        </header>
      </div>
      {navshow && <MobileNav setNavshow={setNavshow} />}
    </>
  );
};

export default Header;
